<template>
  <b-row>
    <b-col class="col-lg-12 col-xs-12">
      <Loader v-if="loading"></Loader>
      <b-card-body v-else>
        <b-table
          striped hover
          :borderless="true"
          :items="rowsData"
          :fields="columns"
        >
          <template v-slot:cell(value)="data">
            <div v-if="data.item.type === 'inputFormatted'" v-html="data.item.value"></div>
            <items-collection-custom-field-values without-label v-else-if="data.item.type === 'itemsCollection'" :data="data.item"></items-collection-custom-field-values>
            <id-user-data-custom-field-value without-label v-else-if="data.item.type === 'idUserData'" :data="data.item"></id-user-data-custom-field-value>
            <span v-else-if="data.item.type === 'multiSelect'">{{data.item.value.join(', ')}}</span>
            <span v-else>{{data.item.value}}</span>
          </template>
        </b-table>
        <b-pagination @change="fetchData($event)" v-model="page" :per-page="perPage" :total-rows="counted" class="mt-4 ml-4"></b-pagination>
        <div class="form-group pb-2 col-sm-12">
          <div class="float-right">
            <b-button v-if="downloadXlsStatus === 0" variant="info" @click="downloadXLS()" v-b-tooltip.hover :title="$t('buttons.downloadXLS')" class="float-left ml-2 mr-2 btn-circle">
              <i class="fal fa-file-spreadsheet"></i>
            </b-button>
            <b-button v-if="downloadXlsStatus === 1" variant="success" v-b-tooltip.hover :title="$t('buttons.downloadXLS')" class="float-left ml-2 mr-2 btn-circle">
              <i class="fal fa-spinner fa-spin"></i>
            </b-button>
          </div>
        </div>
      </b-card-body>
    </b-col>
  </b-row>
</template>

<script>
import { checkPagePermission, checkPermission } from '@/utils/checkRoles'
import ApiService from '@/utils/ApiService'
import Loader from '@/components/Dashboard/Layout/Loader.vue'
import ItemsCollectionCustomFieldValues from '@/components/Dashboard/Views/excmcase/components/itemsCollectionCustomFieldValues.vue'
import IdUserDataCustomFieldValue from '@/components/Dashboard/Views/excmcase/components/idUserDataCustomFieldValue.vue'

export default {
  name: 'caseCustomFields',
  components: { IdUserDataCustomFieldValue, ItemsCollectionCustomFieldValues, Loader },
  data () {
    return {
      loading: true,
      rowsData: [],
      counted: 0,
      page: 1,
      perPage: 10,
      downloadXlsStatus: 0,
      columns: [
        { key: 'caseId', label: this.$t('views.exsborder.list.idCase') },
        { key: 'caseNumber', label: this.$t('views.excmcyclictask.form.caseNumber') },
        { key: 'caseTypeId', label: this.$t('views.excmcyclictask.form.caseTypeId') },
        { key: 'caseTypeTitle', label: this.$t('views.excmcyclictask.form.caseType') },
        { key: 'type', label: this.$t('views.excmcasetype.form.customField.fieldType') },
        { key: 'name', label: this.$t('views.excmcasetype.form.customField.fieldName') },
        { key: 'label', label: this.$t('views.excmcasetype.form.customField.fieldLabel') },
        { key: 'value', label: this.$t('views.excmcasetype.form.customField.customFieldValue.value') }
      ]
    }
  },
  beforeCreate () {
    checkPagePermission('configuration', 'EXCMCustomFieldsReportList')
  },
  created () {
    this.fetchData()
  },
  destroyed () {
  },
  methods: {
    async downloadXLS () {
      this.downloadXlsStatus = 1
      let params = { xls: 1 }
      await new ApiService('reports/excm_case_custom_fields', params).downloadFile('caseCustomFields.xls')
      this.downloadXlsStatus = 0
    },
    async fetchData (page = this.page) {
      this.loading = true
      let params = { page: page }
      let response = await new ApiService('reports/excm_case_custom_fields', params).getResults()
      this.rowsData = response.data
      this.counted = response.counted
      this.perPage = response.perPage
      this.page = response.page
      this.loading = false
    },
    checkRoles (type, view = null, component = null) {
      return checkPermission(type, view, component)
    }
  }
}
</script>
